/** Baker / froster calculator weights: 0.25 kg min, then 0.5 kg steps (0.5, 1, 1.5, …). */

export const CALCULATOR_WEIGHT_MIN = 0.25;
export const CALCULATOR_WEIGHT_MAX = 20;

export function formatCalculatorWeight(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0.5";
  if (Math.abs(n - 0.25) < 0.001) return "0.25";
  const rounded = Math.round(n * 2) / 2;
  return String(Number(rounded.toFixed(2)));
}

export function snapCalculatorWeight(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0.5;
  if (n <= 0.375) return 0.25;
  const steps = Math.max(1, Math.round(n / 0.5));
  return Math.min(CALCULATOR_WEIGHT_MAX, steps * 0.5);
}

export function bumpCalculatorWeight(value, direction) {
  const current = snapCalculatorWeight(value);
  if (direction > 0) {
    if (current <= 0.25) return 0.5;
    return Math.min(CALCULATOR_WEIGHT_MAX, current + 0.5);
  }
  if (current <= 0.5) return CALCULATOR_WEIGHT_MIN;
  return Math.max(0.5, current - 0.5);
}
